module.exports = __webpack_public_path__ + "img/gift4-01-c02-t2.fd06f49a.png";